import { getItemOrDefaultToValue, getValueOfObject } from 'utils/details';
import { ROLES } from '../../constants';
import get from 'lodash/get';
import { checkIfUserIsSimpleUser } from 'utils/helper/roles';

const consolidatedRoles = values => {
  const roles = [];
  const selectedRole = getItemOrDefaultToValue(values, 'role');
  const isResponder = getItemOrDefaultToValue(values, 'isResponder');
  roles.push(selectedRole);
  if (isResponder) {
    roles.push(ROLES.RESPONDER.id);
  }

  return [...new Set(roles)];
};

export const transformUserObject = values => {
  const ids = values?.departments &&
    values?.departments.length > 0 && {
      departmentIds: getItemOrDefaultToValue(
        values,
        'departments',
        undefined,
      )?.map(m => m.id),
    };
  const isUserSimple = checkIfUserIsSimpleUser(values.role);
  const bizClientId = get(values, 'businessClient.id');
  return {
    general: {
      employeeId: getItemOrDefaultToValue(values, 'employeeId'),
      photoBase64: getItemOrDefaultToValue(values, 'image'),
      regionId: getItemOrDefaultToValue(values, 'regionId'),
      securityCompanyId: getItemOrDefaultToValue(values, 'securityCompanyId'),
      securityCompanyName: getItemOrDefaultToValue(
        values,
        'securityCompanyName',
      ),
      ...(!isUserSimple && {
        phoneNumber: {
          number: getItemOrDefaultToValue(values, 'phone'),
          country: getItemOrDefaultToValue(values, 'country'),
        },
      }),
      firstName: getItemOrDefaultToValue(values, 'firstName', '-'),
      lastName: getItemOrDefaultToValue(values, 'lastName', '-'),
      jobRole: getItemOrDefaultToValue(values, 'role', '-'),
      roles: consolidatedRoles(values),
      reliability: 5,
      ...(!isUserSimple && { email: getItemOrDefaultToValue(values, 'email') }),
      businessClientId: bizClientId,
      isTeamLead: getItemOrDefaultToValue(values, 'isTeamLead'),
      ...(ids && { departmentIds: ids.departmentIds }),
    },
    details: {
      password: getItemOrDefaultToValue(values, 'passcode'),
      archived: getItemOrDefaultToValue(values, 'archived', false),
      notes: getItemOrDefaultToValue(values, 'notes', '-'),
      rating: getItemOrDefaultToValue(values, 'rating', 0),
      reliability: 5,
      verifications: {
        phoneVerified: getItemOrDefaultToValue(values, 'phoneVerified'),
        emailVerified: getItemOrDefaultToValue(values, 'emailVerified'),
        idVerified: getItemOrDefaultToValue(values, 'idVerified', false),
      },
      languages: getItemOrDefaultToValue(values, 'languages', []),
      qualifications:
        values.qualifications && getValueOfObject(values, 'qualifications'),
      services: getItemOrDefaultToValue(values, 'services', []),
      assignedSite:
        typeof values.assignedSite === 'object'
          ? getItemOrDefaultToValue(values, 'assignedSite')
          : undefined,
    },
    operational: {
      location: getItemOrDefaultToValue(values, 'location'),
    },
  };
};
